import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {RequestBody} from "../../entity/core/request-body";
import {BrandingTemplateRequest} from "../../entity/model/branding-template-request";

export default class BrandingTemplateAgent {
    createBrandingTemplate = async (organizationId: string, requestBody: RequestBody): Promise<BrandingTemplateRequest> => {
        return API.post(awsApiName, `/organizations/${organizationId}/branding-templates`, requestBody);
    }

    getBrandingTemplates = async (organizationId: string): Promise<BrandingTemplateRequest[]> => {
        return API.get(awsApiName, `/organizations/${organizationId}/branding-templates`, {});
    }
}